var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6666 17.5H17.0116L21.0766 13.435C21.5456 12.9663 21.8092 12.3304 21.8093 11.6673C21.8095 11.0042 21.5462 10.3682 21.0774 9.89922C20.6087 9.43022 19.9728 9.16666 19.3097 9.1665C18.6466 9.16635 18.0106 9.42961 17.5416 9.89838L11.5649 15.875C10.4729 16.9701 9.85962 18.4535 9.85962 20C9.85962 21.5466 10.4729 23.03 11.5649 24.125L17.5416 30.1017C18.0106 30.5705 18.6466 30.8338 19.3097 30.8336C19.9728 30.8334 20.6087 30.5699 21.0774 30.1009C21.5462 29.6319 21.8095 28.9959 21.8093 28.3328C21.8092 27.6697 21.5456 27.0338 21.0766 26.5651L17.0116 22.5H31.6666C32.3296 22.5 32.9655 22.2367 33.4344 21.7678C33.9032 21.299 34.1666 20.6631 34.1666 20C34.1666 19.337 33.9032 18.7011 33.4344 18.2323C32.9655 17.7634 32.3296 17.5 31.6666 17.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.9c710f8ffc6220890f9d03bc234b3817.svg";
export { ForwardRef as ReactComponent };